import { styled, Typography, Theme, Box } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_FIELDS_ON_CARD_HEADER_LINE, LIGHT_HEADER_LINE, PRIMARY_HEADER_LINE } = COLORS;

const $gutter = 30;
export const Heading = styled(Typography)<Theme, { col?: string; theme: any }>(({ col, theme }) => ({
  position: 'relative',
  borderBottom:
    theme.palette.type === 'dark'
      ? '1px solid' + DARK_FIELDS_ON_CARD_HEADER_LINE
      : '1px solid' + LIGHT_HEADER_LINE + '!important',
  alignItems: 'center',
  paddingBottom: 15,
  margin: '10px 0 20px',
  display: 'flex',
  fontWeight: 600,

  '&::before': {
    content: '""',
    background: `${col ? col : PRIMARY_HEADER_LINE}`,
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },
}));

export const AuditionItemsContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 25%)',
  gap: $gutter,
  width: `calc(100% - ${$gutter * 3}px)`,

  [theme.breakpoints.down(1850)]: {
    gridTemplateColumns: 'repeat(2, 50%)',
    width: `calc(100% - ${$gutter}px)`,
  },

  [theme.breakpoints.down(900)]: {
    gridTemplateColumns: 'unset',
    width: '100%',
  },
}));

export const ScrollCont = styled(Box)(({ theme }) => ({
  overflow: 'auto',
  height: 'calc(100vh - 220px)',
  paddingRight: 10,
}));
